import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheOpulentGlowExperience from "./sections/TheOpulentGlowExperience";
import OurPamperingMenu from "./sections/OurPamperingMenu";
import OurPhilosophy from "./sections/OurPhilosophy";
import StandardizationCompliance from "./sections/StandardizationCompliance";
import EnvisionYourSpace from "./sections/EnvisionYourSpace";
import GlobalSuccessStories from "./sections/GlobalSuccessStories";
import OurServices from "./sections/OurServices";
import Map from "./sections/Map";
import Footer from "@/reusable_sections/Footer";
import GetStartedCta from "./sections/GetStartedCta";
import QuoteSection from "./sections/QuoteSection";
export default function HomePage() {
  return <div>
      <Header />
      <TheOpulentGlowExperience />
      <GetStartedCta />
      <QuoteSection />
      <OurPamperingMenu />
      <OurPhilosophy />
      <OurServices />
      <StandardizationCompliance />
      <EnvisionYourSpace />
      <GlobalSuccessStories />
      <Map />
      <Footer />
    </div>;
}